import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import DateReference from './date_reference';

export default function DueDates({ playbook, task, setDueDate }) {
  const operatorOptions = ['after', 'before'];
  const unitsOptions = [
    { label: 'Days', value: 'day' },
    { label: 'Weeks', value: 'week' },
    { label: 'Months', value: 'month' }
  ];

  const dateTypesSet = [
    {
      value: 'relative',
      label: 'Relative Critical Date',
      getTaskDateValues: () => ({ modifier, units, operator, dateReference }),
      isTask: () => (task && task.dateReference)
    },
    {
      value: 'stageUpdate',
      label: 'Days After Stage Update',
      getTaskDateValues: () => ({ modifier, dateReference: null, operator: 'after', units: 'day' }),
      isTask: () => (task && task.modifier != null && task.modifier >= 0 && !task.dateReference)
    },
    {
      value: 'none',
      label: 'None',
      getTaskDateValues: () => ({ modifier: null, dateReference: null }),
      isTask: () => (!task || (!task.modifier && !task.dateReference))
    }
  ];

  const [dateType, setDateType] = useState(dateTypesSet.find(type => type.isTask())?.value || 'none');
  const [modifier, setModifier] = useState(task?.modifier ? task.modifier : 0);
  const [units, setUnits] = useState(task?.units || 'day');
  const [operator, setOperator] = useState(task?.operator || 'before');
  const [dateReference, setDateReference] = useState();

  const dateTypeOptions = dateTypesSet.map(type => (
    { value: type.value, label: type.label }
  ));

  useEffect(() => {
    setDueDate(dateTypesSet.find(element => element.value === dateType).getTaskDateValues());
  }, [dateType, modifier, units, operator, dateReference]);

  return (
    <div>
      <label>Due Dates</label>
      <ManagedInput
        name="dateType"
        options={dateTypeOptions}
        type="radioGroup"
        value={dateType}
        onValueChange={setDateType}
      />

      {
        dateType === 'none' ? null : 
          <ManagedInput
            className="due-dates-input form-control"
            min="0"
            name="modifier"
            type="number"
            value={modifier}
            onValueChange={setModifier}
          />
      }

      {dateType === 'stageUpdate' && <span>Days After Stage Update</span>}

      {
        dateType === 'relative' &&
          <React.Fragment>
            <ManagedInput
              className="due-dates-dropdown form-control"
              name="units"
              type="select"
              value={units}
              onValueChange={setUnits}
            >
              {
                unitsOptions.map(unit => (
                  <option key={unit.value} value={unit.value}>
                    {unit.label}
                  </option>
                ))
              }
            </ManagedInput>

            <ManagedInput
              className="due-dates-dropdown form-control"
              name="operator"
              type="select"
              value={operator}
              onValueChange={setOperator}
            >
              {
                operatorOptions.map(operator => (
                  <option key={operator} value={operator}>
                    {operator.capitalize()}
                  </option>
                ))
              }
            </ManagedInput>
            <br/>
            <DateReference
              dateReference={dateReference}
              playbook={playbook}
              setDateReference={setDateReference}
              task={task}
            />
          </React.Fragment>
      }
    </div>
  );
}

DueDates.propTypes = {
  playbook: PropTypes.object.isRequired,
  setDueDate: PropTypes.func.isRequired,
  task: PropTypes.object
};
